module.exports = __webpack_public_path__ + "9df1161dad868c94421a626d94340751.png";